
import { Options, Vue } from "vue-class-component";
import { getLocalProject } from "@/utils"; //类型
import { store } from "@/store";
import { dispatchUserLogOut } from "@/store/main/actions";
import { readIsLoggedIn, readUserProfile } from "@/store/main/getters";
import { ElMessage } from "element-plus";
import { readMyProjects } from "@/store/project/getters";
import { dispatchGetMyProjects } from "@/store/project/actions";
import { unique_json } from "@/utils";
@Options({
  components: {},
})
export default class Test extends Vue {
  public localProject = Number(getLocalProject()); //得到本地的项目
  public logoUrl = require("../assets/robot_blue.png");
  get getMe() {
    return readUserProfile(store) || "";
  }
  get isLogin() {
    return readIsLoggedIn(store);
  }
  public onClick(url: string) {
    window.location.href = url;
  }
  public get get_is_super() {
    if (readUserProfile(store)?.username == "t_xinxinliu_ex") {
      return true;
    } else {
      return readUserProfile(store)?.is_super;
    }
  }

  public get loginState() {
    const loginState = {
      username: "Cheryl",
      sub: [
        // { title: "执行自动化", path: "/" },
        // { title: "自动化用例", path: "/" },
        // { title: "设置", path: "/" },
      ],
      sub2: [
        // { title: "执行自动化", path: "/" },
        // { title: "自动化用例", path: "/" },
        // { title: "设置", path: "/" },
        {
          title: "运营数据",
          path: "/operational-data",
          icon: "el-icon-document",
        },
        {
          title: "平台监控",
          path: "/platform-monitoring",
          icon: "el-icon-monitor",
        },
      ],
    };

    if (readUserProfile(store)?.is_super) {
      loginState.sub2.splice(1, 0, {
        title: "平台日志",
        path: "/log",
        icon: "el-icon-document",
      });
    }

    return loginState;
  }

  public rotName: any = "";

  public loginOut = {
    icon: "el-icon-user",
    title: "未登录",
    index: "/login_new",
    sub: [{ title: "登录", path: "/login_new" }],
  };

  public handleLogout() {
    dispatchUserLogOut(store);
  }
  public get menuItem() {
    const username = readUserProfile(store)?.username
    let name = ["pagezhang", "v_baofeiyan", "v_yihuideng"];
    let list = [
      { menuName: "首页", href: "/" },
      { menuName: "项目大厅", href: "/project-hall" },
      { menuName: "新游预约榜", href: "/games_new" },
      { menuName: "客户端性能报告", href: "/client-report" },
      // { menuName: "帮助中心", href: "/#" },
      // { menuName: "下载", href: "/#" },
      // { menuName: "工作台", href: "/project_overview" },
      // { menuName: "对象内存", href: "/object_memory" },
    ];

    list.splice(3, 0, {menuName: "预约测试", href: "/test_appointment"});
    // if (this.get_is_super) { //仅超级管理员可以看到预约测试
    //   list.splice(3, 0, {menuName: "预约测试", href: "/test_appointment"});
    // }
    if (this.get_is_super || username == 'gavinjhliu') { //仅超级管理员和gavinjhliu可以看到Token库
      list.splice(5, 0, { menuName: "Token库", href: "/token_library" });
    }

    // console.log(readUserProfile(store));
    // if (name.some((v) => v == readUserProfile(store)?.username) == false) {
    //   list.splice(5, 1);
    // }
    return list;
  }

  public async goto(item: any) {
    this.$router.push(item.href);
    if (item.menuName === "工作台") {
      await dispatchGetMyProjects(store);
      if (readMyProjects(store).length == 0) {
        ElMessage("请先加入一个项目");
      }
    }
  }
}
